const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Shipping+Countries+List+API


function getShippingCountryList() {
    let url = '/api/util/shippingCountries';
    return ufeApi.makeRequest(url, {
        method: 'GET'
    }).then(data => data.errorCode ? Promise.reject(data) : data.countries);
}


module.exports = getShippingCountryList;
